import storageActions from "app/utils/storageActions";

export const initialState = [];

export const chapters = (state = initialState, action) => {
  const { type, ...data } = action;
  switch (type) {
    // case "chapters/index": {
    //   storageActions.saveItem("chapters", action.chapters);
    //   return [...action.chapters];
    // }
    case "chapters/index": {
      let newChapters = action.chapters;
      let chapters = [...state];
      for (let chapter of newChapters) {
        if (chapters.find((c) => c.id == chapter.id)) {
          chapters[chapters.findIndex((ch) => ch.id == chapter.id)] = chapter;
        } else {
          chapters.push(chapter);
        }
      }
      // storageActions.saveItem("chapters", chapters);
      return chapters;
    }
    case "chapters/update": {
      let chapters = [...state];
      if (!chapters.find((c) => c.id == action.chapter.id)) {
        chapters.push(action.chapter);
      } else {
        chapters = chapters.map((c) =>
          c.id == action.chapter.id
            ? {
                ...c,
                ...action.chapter,
              }
            : c
        );
      }
      // storageActions.saveItem("chapters", chapters);
      return chapters;
    }
    default:
      return state;
  }
};
